import './DashboardTableItem.css';
import React, { useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { format } from 'date-fns';
import { SitecoreContextReactContext } from '../../../../utils/SitecoreContextReactContext';
import { get, getDictionaryItem, canUseDOM } from '../../../../utils';
import b64toBlob from 'b64-to-blob';
import { saveAs } from 'file-saver';
import DashboardStatus from '../DashboardStatus/DashboardStatus';
import { IconUpload } from '../icons/upload';
import { IconEvisa } from '../icons/evisa';
import { IconEdit } from '../icons/edit';
import { IconPay } from '../icons/pay';
import { IconCheck } from '../icons/check';
import Loader from '../../../DAcApplication/components/loader';
import { getSessionId } from '../../../DAcApplication/utils';
import Cookies from 'js-cookie';
const DashboardTableItem = _ref => {
  let {
    item,
    labels,
    dictionary,
    settings,
    configuration
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const getStatusLabel = (statusName, isRTL) => {
    if (!statusName) return '';
    return isRTL ? statusName.AR || '' : statusName.EN || '';
  };
  const appNo = item.ApplicationNo || '';
  const sessionId = getSessionId('dashboard');
  const apiKey = get(settings, 'apiKey.jss.value');
  const apiUrl = get(settings, 'apiUrl.jss.value');
  const userTokken = Cookies.get('token') || '';
  return /*#__PURE__*/React.createElement("div", {
    className: `dashboard-table-item row align-items-center ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table-item__col dashboard-table-item__application-no col-6 col-md-2 order-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table-item__label d-md-none"
  }, labels[0]), item.ApplicationNo), /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table-item__col dashboard-table-item__applicant-name col-7 order-2 col-md-3 order-md-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table-item__label d-md-none"
  }, labels[1]), item.ApplicantName.EN), /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table-item__col dashboard-table-item__created-on col-5 order-3 col-md-2 order-md-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table-item__label d-md-none"
  }, labels[2]), format(new Date(item.CreatedDate), 'dd-MM-yyyy')), /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table-item__col dashboard-table-item__status col-6 col-md-2 order-1 order-md-3"
  }, /*#__PURE__*/React.createElement(DashboardStatus, {
    theme: item.StatusId,
    label: getStatusLabel(item.StatusName, rtl)
  })), /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table-item__col dashboard-table-item__action col-12 col-md-3 d-flex order-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-action-wrapper"
  }, item.StatusId === 'DRAFT' && /*#__PURE__*/React.createElement(RedirectButton, {
    appNo: appNo,
    text: getDictionaryItem(dictionary, 'edit'),
    url: get(configuration, 'buttonEditUrl.jss.value.href'),
    icon: /*#__PURE__*/React.createElement(IconEdit, null),
    step: 2
  }), item.StatusId === 'COMPLETE' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RedirectButton, {
    appNo: appNo,
    text: getDictionaryItem(dictionary, 'pay'),
    url: get(configuration, 'buttonPaymentUrl.jss.value.href'),
    icon: /*#__PURE__*/React.createElement(IconPay, null)
  }), /*#__PURE__*/React.createElement(RedirectButton, {
    appNo: appNo,
    text: getDictionaryItem(dictionary, 'edit'),
    url: get(configuration, 'buttonEditUrl.jss.value.href'),
    icon: /*#__PURE__*/React.createElement(IconEdit, null),
    step: 2
  })), item.StatusId === 'REJECTED' && /*#__PURE__*/React.createElement("button", {
    className: "btn btn-secondary dashboard-action-button"
  }, /*#__PURE__*/React.createElement(IconCheck, null), getDictionaryItem(dictionary, 'checkRefundEligibility')), item.StatusId === 'ADDITIONALDOCREQUIRED' && /*#__PURE__*/React.createElement(RedirectButton, {
    appNo: appNo,
    text: getDictionaryItem(dictionary, 'uploadDocuments'),
    url: get(configuration, 'buttonDocumentsUrl.jss.value.href'),
    icon: /*#__PURE__*/React.createElement(IconUpload, null)
  }), item.StatusId === 'APPROVED' && /*#__PURE__*/React.createElement(DownloadVisaButton, {
    appNo: appNo,
    text: getDictionaryItem(dictionary, 'downloadVisa'),
    apiUrl: apiUrl,
    apiKey: apiKey,
    userTokken: userTokken,
    sessionId: sessionId
  }))));
};
const RedirectButton = _ref2 => {
  let {
    appNo = '',
    text = '',
    url = '',
    icon,
    step
  } = _ref2;
  const history = useHistory();
  const handleRedirectClick = e => {
    if (!url) return;
    e.preventDefault();
    history.push(`${url}${appNo}${step ? `&step=${step}` : ''}`);
  };
  return /*#__PURE__*/React.createElement("button", {
    className: "btn btn-secondary dashboard-action-button",
    onClick: handleRedirectClick
  }, icon && icon, text);
};
const DownloadVisaButton = _ref3 => {
  let {
    appNo = '',
    text = '',
    apiUrl,
    apiKey,
    userTokken,
    sessionId
  } = _ref3;
  const [ivVisaLoading, setIvVisaLoading] = useState(false);
  const [cachedData, setCachedData] = useState(null);
  const clickRef = useRef(null);
  const fileUrlRef = useRef(null);
  const [isLinkCreated, setIsLinkCreated] = useState(false);
  const getApprovedDocument = async () => {
    if (cachedData) {
      createDownloadLink(cachedData.base64, cachedData.fileName);
      return;
    }
    setIvVisaLoading(true);
    const url = `${apiUrl}/v1/proxy/application/visa/generate`;
    const headers = new Headers();
    headers.append('X-Request-Id', sessionId);
    headers.append('Apikey', apiKey);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', userTokken);
    headers.append('Host', 'dacqa.detsandbox.com');
    headers.append('User-Agent', 'Apidog/1.0.0 (https://apidog.com)');
    const data = {
      applicationNumber: '' + appNo
    };
    const requestOptions = {
      method: 'POST',
      headers: headers,
      redirect: 'follow',
      keepalive: true,
      withCredentials: true,
      body: JSON.stringify(data)
    };
    await fetch(url, requestOptions).then(response => {
      if (response.status !== 200) {
        throw new Error(`${response.statusText} ${response.status}`);
      }
      return response.json();
    }).then(result => {
      setCachedData({
        base64: result.reportContentAsBase64String,
        fileName: result.fileName
      });
      createDownloadLink(result.reportContentAsBase64String, result.fileName);
    }).catch(error => {
      console.error('Get Approved Document error', error);
    }).finally(() => setIvVisaLoading(false));
  };
  const createDownloadLink = (baseData, fileName) => {
    if (!canUseDOM) return false;
    try {
      const blob = b64toBlob(baseData, 'application/pdf');
      saveAs(blob, fileName);
      return true;
    } catch (error) {
      console.error('error downloading file:', error);
      return false;
    }
  };
  const handleDownloadVisaClick = e => {
    e.preventDefault();
    getApprovedDocument();
  };
  return /*#__PURE__*/React.createElement("button", {
    className: `btn btn-secondary dashboard-action-button ${ivVisaLoading ? 'disabled' : ''}`,
    onClick: handleDownloadVisaClick
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: ivVisaLoading ? 0 : 1
    }
  }, /*#__PURE__*/React.createElement(IconEvisa, null), text), ivVisaLoading && /*#__PURE__*/React.createElement(Loader, {
    className: "dashboard-spinner"
  }));
};
export default DashboardTableItem;
const commonStyles = "cbmlvia";
const ltrStyles = "l17ghboz";
const rtlStyles = "rlwzg7r";